import { render, staticRenderFns } from "./MatchInfo.vue?vue&type=template&id=786b22f6&"
import script from "./MatchInfo.vue?vue&type=script&lang=js&"
export * from "./MatchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MatchInfo.vue"
export default component.exports